export let ProrationModesAndroid = /*#__PURE__*/function (ProrationModesAndroid) {
  ProrationModesAndroid[ProrationModesAndroid["IMMEDIATE_WITH_TIME_PRORATION"] = 1] = "IMMEDIATE_WITH_TIME_PRORATION";
  ProrationModesAndroid[ProrationModesAndroid["IMMEDIATE_AND_CHARGE_PRORATED_PRICE"] = 2] = "IMMEDIATE_AND_CHARGE_PRORATED_PRICE";
  ProrationModesAndroid[ProrationModesAndroid["IMMEDIATE_WITHOUT_PRORATION"] = 3] = "IMMEDIATE_WITHOUT_PRORATION";
  ProrationModesAndroid[ProrationModesAndroid["DEFERRED"] = 4] = "DEFERRED";
  ProrationModesAndroid[ProrationModesAndroid["IMMEDIATE_AND_CHARGE_FULL_PRICE"] = 5] = "IMMEDIATE_AND_CHARGE_FULL_PRICE";
  ProrationModesAndroid[ProrationModesAndroid["UNKNOWN_SUBSCRIPTION_UPGRADE_DOWNGRADE_POLICY"] = 0] = "UNKNOWN_SUBSCRIPTION_UPGRADE_DOWNGRADE_POLICY";
  return ProrationModesAndroid;
}({});
export let PurchaseStateAndroid = /*#__PURE__*/function (PurchaseStateAndroid) {
  PurchaseStateAndroid[PurchaseStateAndroid["UNSPECIFIED_STATE"] = 0] = "UNSPECIFIED_STATE";
  PurchaseStateAndroid[PurchaseStateAndroid["PURCHASED"] = 1] = "PURCHASED";
  PurchaseStateAndroid[PurchaseStateAndroid["PENDING"] = 2] = "PENDING";
  return PurchaseStateAndroid;
}({});
export const PROMOTED_PRODUCT = 'iap-promoted-product';
export let InstallSourceAndroid = /*#__PURE__*/function (InstallSourceAndroid) {
  InstallSourceAndroid[InstallSourceAndroid["NOT_SET"] = 0] = "NOT_SET";
  InstallSourceAndroid[InstallSourceAndroid["GOOGLE_PLAY"] = 1] = "GOOGLE_PLAY";
  InstallSourceAndroid[InstallSourceAndroid["AMAZON"] = 2] = "AMAZON";
  return InstallSourceAndroid;
}({});
export let ProductType = /*#__PURE__*/function (ProductType) {
  ProductType["subs"] = "subs";
  ProductType["sub"] = "sub";
  ProductType["inapp"] = "inapp";
  ProductType["iap"] = "iap";
  return ProductType;
}({});
/**
 * Can be used to distinguish the different platforms' subscription information
 */
export let SubscriptionPlatform = /*#__PURE__*/function (SubscriptionPlatform) {
  SubscriptionPlatform["android"] = "android";
  SubscriptionPlatform["amazon"] = "amazon";
  SubscriptionPlatform["ios"] = "ios";
  return SubscriptionPlatform;
}({});

/** Android Billing v5 type */

/**
 * TODO: As of 2022-10-10, this typing is not verified against the real
 * Amazon API. Please update this if you have a more accurate type.
 */

/** As of 2022-10-12, we only use the `sku` field for Amazon purchases */

/**
 * In order to purchase a new subscription, every sku must have a selected offerToken
 * @see SubscriptionAndroid.subscriptionOfferDetails.offerToken
 */

/** As of 2022-10-12, we only use the `sku` field for Amazon subscriptions */
//# sourceMappingURL=index.js.map